import { useCallback, useMemo, useState } from "react";
import { getV2Identity } from "../auth/v2Auth";
import {
  DEFAULT_INTERNAL_BLOCK_ORDER,
  normalizeInternalBlockOrder,
} from "./v2OverviewConstants";

function storageKey(userId) {
  return `v2_internal_block_order:${userId || "anon"}`;
}

function readOrder(userId) {
  try {
    const raw = window.localStorage.getItem(storageKey(userId));
    if (!raw) return DEFAULT_INTERNAL_BLOCK_ORDER;
    return normalizeInternalBlockOrder(JSON.parse(raw));
  } catch {
    return DEFAULT_INTERNAL_BLOCK_ORDER;
  }
}

export default function useInternalBlockOrder() {
  const userId = getV2Identity().user_id;
  const [order, setOrder] = useState(() => readOrder(userId));

  const save = useCallback((next) => {
    const normalized = normalizeInternalBlockOrder(next);
    setOrder(normalized);
    window.localStorage.setItem(storageKey(userId), JSON.stringify(normalized));
  }, [userId]);

  const reset = useCallback(() => {
    window.localStorage.removeItem(storageKey(userId));
    setOrder(DEFAULT_INTERNAL_BLOCK_ORDER);
  }, [userId]);

  return useMemo(
    () => ({ order, save, reset, defaultOrder: DEFAULT_INTERNAL_BLOCK_ORDER }),
    [order, reset, save],
  );
}
